import type { UsageStatistic } from "../types/subscription";

interface modalMessage {
    title: string;
    message: string;
}

export const subscriptionGuardModalMessage : Record<UsageStatistic, modalMessage> = {
    "employees": { 
        title: "Employee Limit Reached",
        message: "You have reached the maximum number of allowed employees for your subscription plan"
    },

    "stores": { 
        title: "Store Limit Reached",
        message: "You have reached the maximum number of allowed stores for your subscription plan"
    },

    "sales": { 
        title: "Monthly Sales Limit Reached",
        message: "You have reached the maximum number of allowed sales for this month with your current subscription plan"
    },

    "products": { 
        title: "Product Limit Reached",
        message: "You have reached the maximum number of allowed products with your current subscription plan"
    },

    "customers": { 
        title: "Customer Limit Reached",
        message: "You have reached the maximum number of allowed customers with your current subscription plan"
    }
}